import React__default, { useState } from 'react';
import MobileFilterDrawer from '../MobileFilterDrawer/index.js';
import ZigButton from '../../../../../inputs/ZigButton/index.js';
import { Typography } from '@mui/material';

var MobileFilterButton = function (_a) {
    var filter = _a.filter, onChange = _a.onChange, resetFilter = _a.resetFilter, label = _a.label, prefixId = _a.prefixId;
    var _b = useState(false), drawerOpen = _b[0], setDrawerOpen = _b[1];
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MobileFilterDrawer, { filters: filter, onChange: onChange, open: drawerOpen, onClose: function () { return setDrawerOpen(false); }, resetFilters: resetFilter, prefixId: prefixId }),
        React__default.createElement(ZigButton, { variant: "outlined", sx: { p: "2px 14px" }, id: "".concat(prefixId, "__button-").concat(filter.id), onClick: function () { return setDrawerOpen(true); } },
            React__default.createElement(Typography, null, label))));
};

export { MobileFilterButton as default };
